import PropTypes from 'prop-types';
import React from 'react';
import { CircularProgress } from '@material-ui/core';
import useStyles from './Loader.styles';

const Loader = ({ className, style, circularProgressStyle, size }) => {
  const classes = useStyles();

  return (
    <div className={`${classes.loader} ${className}`} style={style}>
      <CircularProgress style={circularProgressStyle} size={size} />
    </div>
  );
};

Loader.propTypes = {
  circularProgressStyle: PropTypes.shape(),
  className: PropTypes.string,
  style: PropTypes.shape(),
  size: PropTypes.number,
};

Loader.defaultProps = {
  circularProgressStyle: undefined,
  className: undefined,
  style: undefined,
  size: 40,
};

export default React.memo(Loader);
